import React, { useEffect, useState } from "react";

import classes from "./Layout.module.css";
import { Alert, Box, Snackbar } from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import { selectInform } from "../../features/notification/notificationSlice";
export const Layout = ({ children, menu, navigate, header }) => {
  return (
    <div className={classes.root}>
      <div className={classes.menu}>{menu}</div>
      <div className={classes.main}>
        <Notification />
        <div className={classes.header}>{header}</div>
        <div className={classes.content}>{children}</div>
        <div className={classes.footer}></div>
      </div>
    </div>
  );
};

function Notification() {
  const inform = useAppSelector(selectInform);
  const [notif, setnotif] = useState({});
  useEffect(() => {
    setnotif(inform);
  }, [inform]);
  const { open, vertical = "top", horizontal = "right", message } = notif;
  const hideNotif = () => {
    setnotif({ ...notif, open: false });
  };
  console.log(inform);
  return (
    <Box sx={{ width: 500 }}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={6000}
        onClose={hideNotif}
        key={vertical + horizontal}
      >
        <Alert onClose={hideNotif} severity="success" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

